import { register } from '../../../JavaScript/Utils'

export const TeaserCard = (el: HTMLElement) => {
    const stepContainer: HTMLElement = el.querySelector('.js_step-container')
    const stepContainerIcon: HTMLElement = el.querySelector('.js_step-container-icon')
    const stepContainerNumber: HTMLElement = el.querySelector('.js_step-container-number')
    const step = el.parentElement.dataset.step

    if (step) {
      if (! stepContainerIcon && stepContainerNumber) {
        stepContainerNumber.innerText = step;
      }
      stepContainer.classList.remove('d-none')
    }
}

register('TeaserCard', TeaserCard)
